import React, { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import HomeIcon from "@material-ui/icons/Home";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
//import Library from '@material-ui/icons/LocalLibrary';
//import Assignment from '@material-ui/icons/Assignment';
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
//import InputLabel from "@material-ui/core/InputLabel";
//import MenuItem from "@material-ui/core/MenuItem";
//import FormControl from "@material-ui/core/FormControl";
//import Select from "@material-ui/core/Select";
//import NativeSelect from "@material-ui/core/NativeSelect";
//import InputBase from "@material-ui/core/InputBase";

import { Link, withRouter, useHistory } from "react-router-dom";

import { useVideoContext } from "../libs/contextLib";

const isActive = (history, path) => {
  if (history.location.pathname === path) return { color: "#ff4081" };
  else return { color: "#ffffff" };
};
const isPartActive = (history, path) => {
  if (history.location.pathname.includes(path))
    return { color: "#fffde7", backgroundColor: "#f57c00", marginRight: 10 };
  else
    return {
      color: "#616161",
      backgroundColor: "#fffde7",
      border: "1px solid #f57c00",
      marginRight: 10,
    };
};

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

function Menu() {
  const classes = useStyles();
  const history = useHistory();
  const { state, dispatch } = useVideoContext();

  return (
    <AppBar position="fixed" style={{ zIndex: 12343455 }}>
      <Toolbar>
        <Typography variant="h6" color="inherit">
          Another YouTube Viewer
        </Typography>
        <div>
          <span style={{ alignItems: "center", display: "flex" }}>
            <Link to="/">
              <IconButton aria-label="Home" style={isActive(history, "/")}>
                <HomeIcon />
              </IconButton>
            </Link>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="large" color="secondary" />}
              aria-label="breadcrumb"
            >
              <Link to="/manage/channels">
                <Button style={isActive(history, "/manage/channels")}>Channels</Button>
              </Link>
              {state.curChannel !== undefined && (
                <Link to="/manage/videos">
                  <Button style={isActive(history, "/manage/videos")}>Videos</Button>
                </Link>
              )}
              {state.curVideo !== undefined && (
                <Link to={"/manage/video/"}>
                  <Button style={isActive(history, "/manage/video/")}>
                    Play Video
                  </Button>
                </Link>
              )}
            </Breadcrumbs>
          </span>
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default withRouter(Menu);
